module.exports = __webpack_public_path__ + "static/media/pr-communication.bcc1436f.svg";